/* tslint:disable */

/**
 */
export class ConsPieToReportParam {
    ENABLE_CONS_PIE?: boolean;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/cons-pie-to-report-param.ts